


export default

	props:

		# URL to link to
		to: String

		# URL to link to
		toExternal: String

		# Size of the button
		size:
			type: String
			validator: (val) -> val in ['small', 'narrow']

		fill:
			type: String
			default: 'solid'
			validator: (val) -> val in ['solid', 'outline']

		color:
			type: String
			default: 'teal'
			validator: (val) -> val in ['teal', 'medium-grey']

		# If a <button>, what type is it
		type:
			type: String
			default: 'button'
			validator: (val) -> val in ['button', 'submit', 'reset']

		# On mobile, expand full width
		expand:
			type: Boolean
			default: true

		# States
		loading: Boolean
		disabled: Boolean

	computed:

		# Root classes
		classes: -> [
			"size-#{@size}" if @size
			"color-#{@color}" if @color
			"fill-#{@fill}" if @fill
			loading: @loading
			if @expand then 'expand' else 'no-expand'
		]

		# States that should supress clicks
		nonInteractive: -> @disabled or @loading

	methods:

		# Prevent clicking if non-interactive
		onClick: (e) ->
			if @nonInteractive
			then e.preventDefault()
			else @$emit 'click'

	# Conditionally change the root button type
	render: (create) ->

		# Make the shared data object
		data =
			class: ['btn', ...@classes]
			domProps: disabled: @nonInteractive
			on: click: @onClick

		# The contents of the button
		children = [
			create 'span', class: 'shape'
			create 'span', class: 'slot', @$nonEmpty [
				@$slots.default
				if @loading then create 'span', class: 'icon-spinner'
			]
		]

		if @to
			create 'nuxt-link', {
				...data
				attrs: {
					...data.attrs
					role: 'button'
				}
				props: { @to }
			}, children

		if @toExternal
			create 'a', {
				...data
				attrs: {
					...data.attrs
					role: 'button'
					href: @toExternal
				}
			}, children

		# Render an html button
		else
			create 'button', {
				...data
				domProps: {
					...data.domProps
					@type
				}
			}, children

